import { render } from "./BookmarkFilter.vue?vue&type=template&id=2a9f6972&scoped=true"
import script from "./BookmarkFilter.vue?vue&type=script&lang=js"
export * from "./BookmarkFilter.vue?vue&type=script&lang=js"

import "./BookmarkFilter.vue?vue&type=style&index=0&id=2a9f6972&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a9f6972"]])

export default __exports__